import { Component } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { AuthenticationService, EnvironmentConfig } from "../../../core/core";
import { ActivityService } from "../../services/activity.service";
import { ActivityTypeBaseComponent } from "../activity-type-base/activity-type-base.component";

declare const environment: EnvironmentConfig;

@Component({
  selector: "common-activity-boolean",
  templateUrl: "./activity-boolean.component.html",
  styleUrls: ["./activity-boolean.component.scss"],
})
export class ActivityBooleanComponent extends ActivityTypeBaseComponent {
  baseImagePath: string;

  terms1;
  terms2;
  terms3;
  terms4;
  available;

  constructor(activityService: ActivityService, authService: AuthenticationService, toastr: ToastrService) {
    super(activityService, authService, toastr);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.baseImagePath = environment.baseImagePath;
  }

  checkedChange() {}

  get disableButton() {
    if (this.available == null) {
      return true;
    }

    if (this.available == false) {
      return false;
    }

    if (!this.terms1 || !this.terms2 || !this.terms3 || !this.terms4) {
      return true;
    }

    return false;
  }
}
